import React from 'react';
export function WhatIsEDMSection() {
  return <section data-id="element-4167">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-4168">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center" data-id="element-4169">
          What is Electric Discharge Machining (EDM)?
        </h2>
      </div>
      <div className="bg-white p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0" data-id="element-4170">
        <div className="grid md:grid-cols-2 gap-12 items-start" data-id="element-4171">
          <div className="space-y-8" data-id="element-4172">
            <p className="text-gray-700 text-lg leading-relaxed" data-id="element-4173">
              Electrical discharge machining (EDM), also known as spark
              machining, spark eroding, die sinking, wire burning or wire
              erosion, is a manufacturing process whereby a desired shape is
              obtained by using electrical discharges (sparks). Material is
              removed from the work piece by a series of rapidly recurring
              current discharges between two electrodes, separated by a
              dielectric liquid and subject to an electric voltage.
            </p>
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/EDM%20Images/What%20is%20EDM.jpg" alt="What is EDM Diagram" className="block w-full h-auto rounded-lg shadow-sm border border-gray-200" data-id="element-4174" />
          </div>

          <div className="space-y-8" data-id="element-4175">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/preview/uploaded/images/EDM%20Images/AgieCharmilles%20Poison%20Arrow.jpg" alt="AgieCharmilles Poison Arrow" className="block w-full h-auto rounded-lg shadow-sm border border-gray-200" data-id="element-4176" />
            <p className="text-gray-700 text-lg leading-relaxed" data-id="element-4177">
              Electrical discharge machining is a machining method primarily
              used for hard metals or those that would be very difficult to
              machine with traditional techniques. EDM typically works with
              materials that are electrically conductive, although methods have
              also been proposed for using EDM to machine insulating ceramics.
              EDM can cut intricate contours or cavities in pre-hardened steel
              without the need for heat treatment to soften and re-harden them.
              This method can be used with any other metal or metal alloy such
              as titanium, hastelloy, kovar, and inconel. Also, applications of
              this process to shape polycrystalline diamond tools have been
              reported.
            </p>
          </div>
        </div>
      </div>
    </section>;
}